
  export const detailsAdapter = (detailsResponse: any): any => {
    //OFERTAS
    const transformedOffersData = detailsResponse?.offers?.map((item: any) => {
        const availableLangs = Object.keys(item);
        if (!availableLangs || availableLangs.length === 0) 
          return undefined;

        const groupedFields = Object.keys(item[availableLangs[0]]).reduce((acc: any, key) => {
          if (key !== 'start' && key !== 'end') {
            acc[key] = {};
            availableLangs.forEach(lang => {
              acc[key][lang] = item?.[lang]?.[key];
            });
          }
          return acc;
        }, {});
  
        groupedFields.start = item.es.start;
        groupedFields.end = item.es.end;
        return groupedFields;
    });
  
    //POINT COORDINATES
    const [lat, lng] = detailsResponse.coordinates ? detailsResponse.coordinates?.split(',') : [null, null];
  
    //POINT MULTIMEDIA (IMAGE, VIDEO SLIDER)
    const multimedia = detailsResponse.multimedia?.map(item => ({ name: item.name, type: item.type }));
  
    //ALL POINT BUTTONS
    let combinedActionButtonsArray = [];
    if (detailsResponse.links && !Array.isArray(detailsResponse.links)) {
      const linkButtons = getLinksButtons(detailsResponse.links);
      combinedActionButtonsArray = [...combinedActionButtonsArray, linkButtons];
    }
    if (detailsResponse.files && !Array.isArray(detailsResponse.files)) {
      const fileButtons = getFileButtons(detailsResponse.files);
      combinedActionButtonsArray = [...combinedActionButtonsArray, fileButtons];
    }

    const actionButtons = getCombinedActionButtons(combinedActionButtonsArray);
  
    return {
      id: typeof detailsResponse.id === 'string' ? parseInt(detailsResponse.id) : detailsResponse.id,
      name: detailsResponse.name ?? null,
      description: detailsResponse.description?.length === 0 ? null : detailsResponse.description,
      location: lat && lng ? { lat: parseFloat(lat), lng: parseFloat(lng), address: detailsResponse.location} : null,
      duration: detailsResponse?.duration ? { hours: Math.floor(detailsResponse.duration / 60), minutes: detailsResponse.duration % 60 } : null,
      schedule: detailsResponse.opening_times?.length === 0 ? null : detailsResponse.opening_times,
      photo_360: detailsResponse.photo_360,
      speaker: detailsResponse.speaker,
      action_buttons: actionButtons ?? null,
      multimedia: multimedia ?? null,
      extra_fields: detailsResponse.extra_fields?.length === 0 ? null : detailsResponse.extra_fields,
      price: detailsResponse.price ?? null,
      type: detailsResponse.type,
      dateRange: detailsResponse.start &&  detailsResponse.end ? {start: detailsResponse.start, end: detailsResponse.end} : null,
      tags: detailsResponse.tags?.length === 0 ? null : detailsResponse.tags,
      accessibility: detailsResponse.accesibility?.length === 0 ? null : detailsResponse.accesibility,
      offers: transformedOffersData ?? null,
      audioguides: detailsResponse?.audioguides,
      gpxFile: detailsResponse?.gpx_file
    };
  };
  
  
  function getCombinedActionButtons(buttonsArray: any[]) {
    if (buttonsArray.length === 0) 
      return null;

    let combinedActionButtons = {};
    const allKeys = new Set(buttonsArray.flatMap(buttons => Object.keys(buttons)));
    allKeys?.forEach(key => {
      const combinedButtons = [];
      buttonsArray.forEach(buttons => {
        if (buttons?.[key]) 
            combinedButtons.push(...buttons[key]);
      });
      if (combinedButtons.length > 0) 
        combinedActionButtons[key] = combinedButtons;
    });
    if (Object.keys(combinedActionButtons).length === 0) 
      return null;

    return combinedActionButtons;
  }
  
  function getLinksButtons(items: any) {
    let actionButtons = Object.keys(items)?.reduce((acc: any, key) => {
        if (items?.[key]) {
            const buttons = items?.[key]?.map((button: any) => {
                let buttonType = '';
                switch (button.show) {
                    case 'qr': buttonType = 'qr'; break;
                    case 'iframe': buttonType = 'iframe'; break;
                    case 'link': buttonType = 'link'; break;
                }
    
                return {
                    button_text: button.button_text,
                    url: button.link,
                    type: buttonType,
                };
            });

          acc[key] = buttons;
        }
        return acc;
      },{}
    );
    return actionButtons;
  }
  
  function getFileButtons(items: any) {
    let actionButtons = Object.keys(items)?.reduce((acc: any, key) => {
        const buttons = items?.[key]?.map((button: any) => {
          return {
            button_text: button.text_button,
            url: button.src,
            type: button.type === 'application/pdf' ? 'pdf' : 'link',
          }
        });
        acc[key] = buttons;
        return acc;
      },
      {}
    );
    return actionButtons;
  }
  